import classnames from "classnames";
import React, { Fragment } from "react";

import { head } from "@utils/array";
import { SalesIncentiveType } from "@utils/enums";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { ProductLabel } from "@components/Product/Layout/ProductLabel/productLabel.component";

import { SalesIncentive } from "../../../../../@types/service/product/shared";

type Props = {
    salesIncentives: Array<SalesIncentive>;
    discountPercentage?: number | null;
    formattedCashBackValue?: string;
    className?: string;
};

const PromotionLabel = ({
    salesIncentives,
    discountPercentage,
    formattedCashBackValue,
    className,
}: Props) => {
    const { t } = useGranite();

    const highestPrioIncentive = head(
        salesIncentives.sort((a, b) => a.order - b.order),
    );

    const discountIncentives = [
        SalesIncentiveType.ActiePrijs,
        SalesIncentiveType.FolderPrijs,
        SalesIncentiveType.CombinatiePrijs,
        SalesIncentiveType.OutletPrijs,
        SalesIncentiveType.KortingProcent,
    ];

    return (
        <Fragment>
            {discountIncentives.some(i => i === highestPrioIncentive?.type) && (
                <div className={classnames("mr-2", className)}>
                    <ProductLabel
                        text={t("promotionLabel.promo")}
                        size="sm"
                        secondary={
                            discountPercentage
                                ? `${Math.floor(discountPercentage)}%`
                                : undefined
                        }
                    />
                </div>
            )}
            {highestPrioIncentive?.type ===
                SalesIncentiveType.EveryDayLowPrice && (
                <div className={classnames("mr-2", className)}>
                    <ProductLabel
                        text={t("promotionLabel.everydaylowprice")}
                        size="xs"
                    />
                </div>
            )}
            {highestPrioIncentive?.type ===
                SalesIncentiveType.GratisTransport && (
                <div className={classnames("mr-2", className)}>
                    <ProductLabel
                        text={t("promotionLabel.freeTransport")}
                        size="xs"
                    />
                </div>
            )}
            {highestPrioIncentive?.type === SalesIncentiveType.Cashback &&
                formattedCashBackValue && (
                    <div className={classnames("mr-2", className)}>
                        <ProductLabel
                            text={t("promotionLabel.cashback")}
                            secondary={formattedCashBackValue}
                            size="sm"
                        />
                    </div>
                )}
            {highestPrioIncentive?.type ===
                SalesIncentiveType.GratisArtikel && (
                <div className={classnames("mr-2", className)}>
                    <ProductLabel
                        text={t("promotionLabel.freeArticle")}
                        size="sm"
                    />
                </div>
            )}
        </Fragment>
    );
};

export { PromotionLabel };
